<template>
  <div>
    <b-card-actions action-collapse title="Detailed Voyage">
      <div>
        <div class="btn-delete-all text-right">
          <b-button
            variant="gradient-primary"
            class="btn-icon btn-delete-all mr-1"
            @click="saveVoyage()"
          >
            <feather-icon icon="SaveIcon" />
          </b-button>
          <b-button
            variant="gradient-primary"
            class="btn-icon mr-1"
            @click="downloadXLSX"
          >
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table @on-select-file="uploadXLSX" class="btn-icon-upload">
            Upload
            <feather-icon icon="UploadIcon" />
          </vue-xlsx-table>
        </div>
        <div>
          <b-row v-if="voyage.stopovers.length === 0">
             <b-col b-col cols="12" lg="12" md="12" sm="12">
              <h3>Initial trip</h3>
              <br>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Start date">
                <b-form-datepicker
                  placeholder="Date"
                  v-model="firstVoyage.startDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="End date">
                <b-form-datepicker
                  placeholder="Date"
                  v-model="firstVoyage.endDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Port of Loading">
                <v-select
                  placeholder="Port"
                  :options="ports"
                  v-model="firstVoyage.loadingPort"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Port of Discharging">
                <v-select
                  placeholder="Port"
                  :options="ports"
                  v-model="firstVoyage.dischargePort"
                  @input="updateStop"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col lg="1" md="1" cols="12">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="addStop"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>
            <b-col lg="12" md="12" cols="12">
              <b-form-group>
                <b-form-checkbox
                  v-model="firstVoyage.transshipmentCheck"
                  true-value="true"
                  false-value="false"
                  @input="addTransFirstVoyage(firstVoyage.transshipmentCheck)"
                  >Transshipment</b-form-checkbox
                >
              </b-form-group>
              <br />
            </b-col>
            <b-row class="voyage-row" v-if="firstVoyage.transshipmentCheck">
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Vessel">
                  <v-select
                    placeholder="Vessel"
                    label="title"
                    v-model="firstVoyage.transshipment.vessel"
                    :options="vessels"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Num Voyage" label-for="num">
                  <b-form-input
                    id="num"
                    placeholder="Num Voyage"
                    v-model="firstVoyage.transshipment.numero"
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Start date">
                  <b-form-datepicker
                    placeholder="Voyage"
                    v-model="firstVoyage.transshipment.startDate"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="End date">
                  <b-form-datepicker
                    placeholder="Voyage"
                    v-model="firstVoyage.transshipment.endDate"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Loading">
                  <v-select
                    v-model="firstVoyage.transshipment.loadingPort"
                    placeholder="Depart"
                    :options="ports"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Discharging">
                  <v-select
                    v-model="firstVoyage.transshipment.dischargePort"
                    placeholder="Arrival"
                    :options="ports"
                  >
                  </v-select>
                </b-form-group>
                <br />
              </b-col>
            </b-row>
          </b-row>
          <br />
          <b-row v-for="(item, i) in stopovers" :id="i" :key="i">

            <b-col b-col cols="12" lg="12" md="12" sm="12">
              <h3>Initial trip</h3>
              <br>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Start date">
                <b-form-datepicker
                  placeholder="Date"
                  v-model="item.startDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="End date">
                <b-form-datepicker
                  placeholder="Date"
                  v-model="item.endDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="From" label-for="from">
                <v-select
                  id="from"
                  placeholder="Port"
                  :options="ports"
                  v-model="item.loadingPort"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="To" label-for="to">
                <v-select
                  id="to"
                  placeholder="Port"
                  :options="ports"
                  v-model="item.dischargePort"
                  @input="updateDepartPort(item, i)"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              lg="1"
              md="1"
              cols="12"
              v-if="voyage.stopovers.length === 0 || i !== stopovers.length - 1"
            >
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="addStop(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>
            <b-col
              lg="1"
              md="1"
              v-if="
                voyage.stopovers.length === 0 ||
                (i !== stopovers.length - 1 && i !== 0)
              "
            >
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                @click="removeStop(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <b-col lg="12" md="12" cols="12">
              <b-form-group>
                <b-form-checkbox
                  v-model="item.transshipmentCheck"
                  true-value="true"
                  false-value="false"
                  @input="addTransshipment(item.transshipmentCheck, i)"
                  >Transshipment</b-form-checkbox
                >
              </b-form-group>
              <br />
            </b-col>
            <b-row class="voyage-row" v-if="item.transshipmentCheck">
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Vessel">
                  <v-select
                    placeholder="Vessel"
                    label="title"
                    v-model="item.transshipment.vessel"
                    :options="vessels"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Num Voyage" label-for="num">
                  <b-form-input
                    id="num"
                    placeholder="Num Voyage"
                    v-model="item.transshipment.numero"
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Start date">
                  <b-form-datepicker
                    placeholder="Voyage"
                    v-model="item.transshipment.startDate"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="End date">
                  <b-form-datepicker
                    placeholder="Voyage"
                    v-model="item.transshipment.endDate"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Loading">
                  <v-select
                    v-model="item.transshipment.loadingPort"
                    placeholder="Depart"
                    :options="ports"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Discharging">
                  <v-select
                    v-model="item.transshipment.dischargePort"
                    placeholder="Arrival"
                    :options="ports"
                  >
                  </v-select>
                </b-form-group>
                <br />
              </b-col>
            </b-row>
          </b-row>
          <br />
          <b-row v-if="voyage.stopovers.length === 0">
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Start date">
                <b-form-datepicker
                  placeholder="Voyage"
                  v-model="lastVoyage.startDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="End date">
                <b-form-datepicker
                  placeholder="Voyage"
                  v-model="lastVoyage.endDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Port of Loading">
                <v-select
                  placeholder="Port"
                  :options="ports"
                  v-model="lastVoyage.loadingPort"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Port of Discharging">
                <v-select
                  placeholder="Port"
                  :options="ports"
                  v-model="lastVoyage.dischargePort"
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col lg="12" md="12" cols="12">
              <b-form-group>
                <b-form-checkbox
                  v-model="lastVoyage.transshipmentCheck"
                  true-value="true"
                  false-value="false"
                  @input="addTransLastVoyage(lastVoyage.transshipmentCheck)"
                  >Transshipment</b-form-checkbox
                >
              </b-form-group>
              <br />
            </b-col>
            <b-row class="voyage-row" v-if="lastVoyage.transshipmentCheck">
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Vessel">
                  <v-select
                    placeholder="Vessel"
                    label="title"
                    v-model="lastVoyage.transshipment.vessel"
                    :options="vessels"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Num Voyage" label-for="num">
                  <b-form-input
                    id="num"
                    placeholder="Num Voyage"
                    v-model="lastVoyage.transshipment.numero"
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Start date">
                  <b-form-datepicker
                    placeholder="Voyage"
                    v-model="lastVoyage.transshipment.startDate"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="End date">
                  <b-form-datepicker
                    placeholder="Voyage"
                    v-model="lastVoyage.transshipment.endDate"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Loading">
                  <v-select
                    v-model="lastVoyage.transshipment.loadingPort"
                    placeholder="Depart"
                    :options="ports"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Discharging">
                  <v-select
                    v-model="lastVoyage.transshipment.dischargePort"
                    placeholder="Arrival"
                    :options="ports"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-row>
        </div>
      </div>
    </b-card-actions>
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormDatepicker,
  BAvatar,
  BPagination,
  BImg,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import * as XLSX from "xlsx";
import moment from "moment";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
    vSelect,
    BFormDatepicker,
    BAvatar,
    BPagination,
    BImg,
    VueGoodTable,
    BFormCheckbox,
    XLSX,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      voyage: {
        vessel: "",
        loadingPort: "",
        dischargePort: "",
        startDate: "",
        endDate: "",
        stopovers: [],
      },
      stopovers: [
        {
          transshipmentCheck: false,
          id: 0,
          loadingPort: "",
          dischargePort: "",
          startDate: "",
          endDate: "",
          transshipment: {
            vessel: "",
            numero: "",
            loadingPort: "",
            dischargePort: "",
            startDate: "",
            endDate: "",
          },
        },
      ],
      firstVoyage: {
        transshipmentCheck: false,
        loadingPort: "",
        dischargePort: "",
        startDate: "",
        endDate: "",
      },
      lastVoyage: {
        transshipmentCheck: false,
        loadingPort: "",
        dischargePort: "",
        startDate: "",
        endDate: "",
      },
      ports: [],
      copyPorts: [],
      vessels: [],
      transshipment: [],
    };
  },
  async created() {
    await this.getVoyage();
    await this.getPorts();
    await this.getVessels();
  },
  methods: {
    async getVoyage() {
      const id = this.$router.history.current.query.id;
      const response = await axios.get(
        `https://mtl-feeder-nodejs.onrender.com/api/voyages`,
        {
          params: { id },
        }
      );
      this.voyage = response.data.data;
      this.stopovers = JSON.parse(JSON.stringify(this.voyage.stopovers));
      this.firstVoyage.loadingPort = this.voyage.loadingPort;
      this.lastVoyage.dischargePort = this.voyage.dischargePort;
      this.firstVoyage.startDate = this.voyage.startDate;
      this.lastVoyage.endDate = this.voyage.endDate;
      this.stopovers.forEach((stop, index) => {
        if (!("transshipmentCheck" in stop)) {
          this.$set(stop, "transshipmentCheck", false);
        }
        if (stop.transshipment) {
          this.$set(stop, "transshipmentCheck", true);
          this.stopovers[index].transshipment = stop.transshipment;
          this.$set(this.stopovers[index], "transshipment", stop.transshipment);
        }
      });
      console.log(this.stopovers);
    },
    async getPorts() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/ports"
      );
      response.data.data.forEach((element, index) => {
        this.ports.push({
          label: element.title,
          value: element._id,
        });
      });
      this.copyPorts = this.ports;
    },
    async getVessels() {
      this.vessels = [];
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/vessels"
      );
      response.data.data.forEach((element) => {
        if(element.title !== this.voyage.vessel){
          this.vessels.push(element.title);
        }
      });
    },
    addTransFirstVoyage(check) {
      if (check) {
        this.firstVoyage.transshipment = {};
      } else {
        delete this.firstVoyage.transshipment;
      }
    },
    addTransLastVoyage(check) {
      if (check) {
        this.lastVoyage.transshipment = {};
      } else {
        delete this.lastVoyage.transshipment;
      }
    },
    addTransshipment(check, index) {
      if (check) {
        this.stopovers[index].transshipment = {};
      } else {
        delete this.stopovers[index].transshipment;
      }
    },
    updateToPorts(port) {
      this.ports = port
        ? this.copyPorts.filter((item) => item.value !== port.value)
        : this.copyPorts;
    },
    updateStop() {
      if (this.stopovers.length === 0) {
        this.lastVoyage.loadingPort = this.firstVoyage.dischargePort;
      } else {
        this.stopovers[0].loadingPort = this.firstVoyage.dischargePort;
      }
    },
    updateDepartPort(item, index) {
      if (this.stopovers[index + 1]) {
        this.stopovers[index + 1].loadingPort = item.dischargePort;
      } else {
        this.lastVoyage.loadingPort = item.dischargePort;
      }
    },
    addStop(index) {
      this.lastVoyage.loadingPort = "";
      const stop = {
        id: index + 1,
        loadingPort: "",
        dischargePort: "",
        startDate: "",
        endDate: "",
        transshipmentCheck: false,
      };
      if (this.stopovers.length === 0) {
        stop.loadingPort = this.firstVoyage.dischargePort;
      } else {
        stop.loadingPort =
          this.stopovers[this.stopovers.length - 1].dischargePort.label;
      }
      this.stopovers.splice(index + 1, 0, stop);
    },
    removeStop(i) {
      this.stopovers.splice(i, 1);
    },
    async saveVoyage() {
      const id = this.$router.history.current.query.id;
      if (
        this.voyage.stopovers.length === 0 &&
        (this.firstVoyage.dischargePort === "" ||
          this.firstVoyage.dischargePort === null ||
          this.lastVoyage.loadingPort === "" ||
          this.lastVoyage.loadingPort === null ||
          this.lastVoyage.startDate === "" ||
          this.lastVoyage.startDate === null ||
          this.firstVoyage.endDate === "" ||
          this.firstVoyage.endDate === null)
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Fill out the form",
            icon: "EditIcon",
            variant: "warning",
          },
        });
      } else {
        const voyagePorts = JSON.parse(JSON.stringify(this.stopovers));
        if (this.voyage.stopovers.length === 0) {
          voyagePorts.unshift(this.firstVoyage);
          voyagePorts.push(this.lastVoyage);
        }
        const hasEmptyVariable = this.stopovers.some((obj) =>
          Object.values(obj).some((value) => value === "" || value === null)
        );
        this.hasTrans = true;
        this.hasEmptyTrans = false;
        voyagePorts.forEach((element) => {
          if (element.transshipmentCheck) {
            this.hasTrans =
              element.transshipment.hasOwnProperty("vessel") &&
              element.transshipment.hasOwnProperty("numero") &&
              element.transshipment.hasOwnProperty("loadingPort") &&
              element.transshipment.hasOwnProperty("dischargePort") &&
              element.transshipment.hasOwnProperty("startDate") &&
              element.transshipment.hasOwnProperty("endDate");
            this.hasEmptyTrans = Object.values(element.transshipment).some(
              (value) => value === "" || value === null
            );
          }
        });
        console.log(hasEmptyVariable);
        if (hasEmptyVariable || this.hasEmptyTrans || this.hasTrans === false) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Fill out the form",
              icon: "EditIcon",
              variant: "warning",
            },
          });
        } else {
          for (let i = 0; i < voyagePorts.length; i++) {
            voyagePorts[i].loadingPort = voyagePorts[i].loadingPort.label
              ? voyagePorts[i].loadingPort.label
              : voyagePorts[i].loadingPort;
            voyagePorts[i].dischargePort = voyagePorts[i].dischargePort.label
              ? voyagePorts[i].dischargePort.label
              : voyagePorts[i].dischargePort;
            if (voyagePorts[i].transshipmentCheck) {
              voyagePorts[i].transshipment.loadingPort = voyagePorts[i]
                .transshipment.loadingPort.label
                ? voyagePorts[i].transshipment.loadingPort.label
                : voyagePorts[i].transshipment.loadingPort;
              voyagePorts[i].transshipment.dischargePort = voyagePorts[i]
                .transshipment.dischargePort.label
                ? voyagePorts[i].transshipment.dischargePort.label
                : voyagePorts[i].transshipment.dischargePort;
            }
          }
          const voyageForm = JSON.parse(JSON.stringify(this.voyage));
          if (this.voyage.stopovers.length === 0) {
            voyageForm.loadingPort = this.firstVoyage.loadingPort;
            voyageForm.dischargePort = this.lastVoyage.dischargePort;
            voyageForm.startDate = this.firstVoyage.startDate;
            voyageForm.endDate = this.lastVoyage.endDate;
          } else {
            voyageForm.loadingPort = voyagePorts[0].loadingPort;
            voyageForm.dischargePort =
              voyagePorts[voyagePorts.length - 1].dischargePort;
            voyageForm.startDate = voyagePorts[0].startDate;
            voyageForm.endDate = voyagePorts[voyagePorts.length - 1].endDate;
          }
          voyageForm.stopovers = voyagePorts;
          this.transshipment = voyagePorts
            .filter((voyage) => voyage.transshipmentCheck)
            .map((voyage) => ({
              ...voyage.transshipment,
              voyage: this.$router.history.current.query.id,
            }));
          if (this.transshipment.length != 0) {
            this.transshipment.forEach(async (transshipment) => {
              await axios.post(
                `https://mtl-feeder-nodejs.onrender.com/api/transshipment`,
                transshipment
              );
            });
          }
          axios
            .put(
              `https://mtl-feeder-nodejs.onrender.com/api/voyages/${id}`,
              voyageForm
            )
            .then(async (response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "voyage updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error during update",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            });
        }
      }
    },
    downloadXLSX() {
      const voyages = JSON.parse(JSON.stringify(this.stopovers));
      voyages.forEach((voyage, index) => {
        if (voyage.loadingPort.label) {
          voyages[index].loadingPort = voyage.loadingPort.label;
        }
        if (voyage.dischargePort.label) {
          voyages[index].dischargePort = voyage.dischargePort.label;
        }
        if (
          voyage.transshipment &&
          voyage.transshipment.loadingPort &&
          voyage.transshipment.loadingPort.label
        ) {
          voyages[index].transshipment.loadingPort =
            voyage.transshipment.loadingPort.label;
        }
        if (
          voyage.transshipment &&
          voyage.transshipment.dischargePort &&
          voyage.transshipment.dischargePort.label
        ) {
          voyages[index].transshipment.dischargePort =
            voyage.transshipment.dischargePort.label;
        }
      });
      const data = [];
      voyages.forEach((voyage) => {
        data.push({
          "Start Date": moment(voyage.startDate).format("MM/DD/YYYY"),
          "End Date": moment(voyage.endDate).format("MM/DD/YYYY"),
          "Loading Port": voyage.loadingPort,
          "Discharge Port": voyage.dischargePort,
          "Vessel (Transshipment)":
            voyage.transshipment && voyage.transshipment.vessel
              ? voyage.transshipment.vessel
              : "",
          "Num Voyage (Transshipment)":
            voyage.transshipment && voyage.transshipment.numero
              ? voyage.transshipment.numero
              : "",
          "Start Date (Transshipment)":
            voyage.transshipment && voyage.transshipment.startDate
              ? moment(voyage.transshipment.startDate).format("MM/DD/YYYY")
              : "",
          "End Date (Transshipment)":
            voyage.transshipment && voyage.transshipment.endDate
              ? moment(voyage.transshipment.endDate).format("MM/DD/YYYY")
              : "",
          "Loading Port (Transshipment)":
            voyage.transshipment && voyage.transshipment.loadingPort
              ? voyage.transshipment.loadingPort
              : "",
          "Discharge Port (Transshipment)":
            voyage.transshipment && voyage.transshipment.dischargePort
              ? voyage.transshipment.dischargePort
              : "",
        });
      });
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Voyages");
      XLSX.writeFile(workbook, "Voyage.xlsx");
    },

    uploadXLSX(convertedData) {
      const data = [];
      let transshipment = [];
      let transshipmentCheck = false;
      convertedData.body.forEach((element) => {
        if (
          element["Start Date (Transshipment)"] !== "" &&
          element["End Date (Transshipment)"] !== ""
        ) {
          transshipment = {
            vessel: element["Vessel (Transshipment)"],
            numero: element["Num Voyage (Transshipment)"],
            startDate: new Date(element["Start Date (Transshipment)"]),
            endDate: new Date(element["End Date (Transshipment)"]),
            loadingPort: element["Loading Port (Transshipment)"],
            dischargePort: element["Discharge Port (Transshipment)"],
          };
          transshipmentCheck = true;
        }
        data.push({
          startDate: new Date(element["Start Date"]),
          endDate: new Date(element["End Date"]),
          loadingPort: element["Loading Port"],
          dischargePort: element["Discharge Port"],
          transshipment: transshipment,
          transshipmentCheck: transshipmentCheck,
        });
      });
      this.stopovers = this.stopovers.concat(data);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.voyage-row {
  width: 100% !important;
  padding: 0 1.1rem !important;
}
.btn-icon-upload button {
  background-image: linear-gradient(47deg, #010022, #030055) !important;
  padding: 0.715rem 0.736rem;
  text-align: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.358rem;
}
</style>